<form novalidate class="rounded-md p-6 bg-primary-purple-light-2 shadow-lg flex flex-col gap-8 max-w-xl" (ngSubmit)="onSubmit()">
  <section class="flex flex-col gap-6">
    <section class="relative flex items-center justify-between">
      @if (!openedByClick() && assignmentStep()) {
        <img [src]="images.sidebar.trips" class="filter-primary-purple-light w-5 h-5 mr-2" />
      }
      <h3 class="w-full text-lg font-bold text-primary-purple">
        @if (openedByClick()) {
          {{ literalService.get(isTrip() ? 'vehicles.actions.editSchedule.tripTitle' : 'vehicles.actions.editSchedule.availabilityTitle', true) }}
        } @else if (conflicts() && conflicts().length) {
          {{ literalService.get('vehicles.actions.editSchedule.conflicts.title', true) }}
        } @else if (assignmentStep()) {
          {{ literalService.get('vehicles.actions.editSchedule.updateTrips', true) }}
        }
      </h3>
      <div class="flex gap-2">
        @if (isTrip()) {
          <button type="button" class="rounded-lg w-5 h-5 inline-flex justify-center items-center" (click)="goToTrip()">
            <img [src]="images.sidebar.trips" class="h-5 w-5" />
          </button>
        }
        <button type="button" class="rounded-lg w-5 h-5 inline-flex justify-center items-center" (click)="close()">
          <img [src]="images.close" class="h-5 w-5" />
        </button>
      </div>
    </section>
    @if (openedByClick()) {
      <section class="flex flex-col gap-6">
        <div class="flex flex-wrap gap-4">
          <div class="flex items-center gap-2">
            <img [src]="images.driver" alt="driver" class="w-5 h-5 shrink-0" [ngClass]="locked() ? 'filter-neutrals-grey-04' : 'filter-primary-purple-light'" />
            @if (locked()) {
              <label
                id="schedule-edit-driver"
                class="w-30 truncate text-neutrals-grey-04"
                [tooltip]="driver()?.name ?? ''"
                [visibleTooltip]="utilsService.visibleTooltip('schedule-edit-driver')"
              >{{ driver()?.name }}</label>
            } @else {
              <app-driver-select class="w-30" [clientId]="availability().managerClientId" [clientIds]="clientIds()" [value]="driver()?.id" [extraOptions]="driverOptions()" (driverSelected)="changeDriver($event)" />
            }
          </div>
          <div class="flex items-center gap-2">
            <img [src]="images.busCar" alt="vehicle" class="w-5 h-5 shrink-0" [ngClass]="locked() ? 'filter-neutrals-grey-04' : 'filter-primary-purple-light'" />
            @if (locked()) {
              <label
                id="schedule-edit-vehicle"
                class="w-30 truncate text-neutrals-grey-04"
                [tooltip]="vehicle()?.name ?? ''"
                [visibleTooltip]="utilsService.visibleTooltip('schedule-edit-vehicle')"
              >{{ vehicle()?.name }}</label>
            } @else {
              <app-vehicle-select class="w-30" [clientId]="availability().managerClientId" [clientIds]="clientIds()" [value]="vehicle()?.id" [extraOptions]="vehicleOptions()" (vehicleSelected)="changeVehicle($event)" />
            }
          </div>
          <div class="flex items-center gap-2">
            <img [src]="images.clock" alt="startTime" class="w-5 h-5 shrink-0" [ngClass]="locked() ? 'filter-neutrals-grey-04' : 'filter-primary-purple-light'" />
            @if (locked()) {
              <label
                id="schedule-edit-times"
                class="w-30 truncate text-neutrals-grey-04"
                [tooltip]="timesLabel()"
                [visibleTooltip]="utilsService.visibleTooltip('schedule-edit-times')"
              >{{ timesLabel() }}</label>
            } @else {
              <app-input class="w-16" [data]="startTimeInput()" [edit]="true" [independent]="true" (change)="changeStartTime($event)" />
              <app-input class="w-16" [data]="endTimeInput()" [edit]="true" [independent]="true" (change)="changeEndTime($event)" />
            }
          </div>
        </div>
        <div class="flex items-center gap-6">
          <app-service-tag [serviceInfo]="availability().service!" />
          <div class="flex items-center gap-2">
            <img [src]="images.sidebar.services" class="w-5 h-5" [ngClass]="locked() ? 'filter-neutrals-grey-04' : 'filter-primary-purple-light'" [alt]="`service ${availability().service?.name}`" />
            <label class="font-base font-semibold" [ngClass]="{'text-neutrals-grey-04': locked()}">{{ availability().service?.name }}</label>
          </div>
          @if (routeName()) {
            <div class="flex items-center gap-2">
              <img [src]="images.route" class="w-5 h-5" [class.filter-neutrals-grey-04]="locked()" [class.filter-primary-purple-light]="!locked()" alt="" aria-hidden="true" />
              <span class="font-base font-semibold" [class.text-neutrals-grey-04]="locked()">{{ routeName() }}</span>
            </div>
          }
        </div>
      </section>
    }
    @if (assignmentStep() && !conflicts().length) {
      <section class="flex flex-col gap-2">
        @if (openedByClick()) {
          <div class="flex gap-2">
            <img [src]="images.sidebar.trips" class="filter-primary-purple-light w-5 h-5" />
            <h4 class="font-semibold text-primary-purple">{{ literalService.get('vehicles.actions.editSchedule.updateTrips', true) }}</h4>
          </div>
        }
        <app-checkbox
          [id]="'schedule-apply-to-trips'"
          [text]="literalService.get('vehicles.actions.editSchedule.applyToTrips', true)"
          [checked]="applyToTrips()"
          (onChange)="changeApplyToTrips($event)"
        />
      </section>
    }
    @if (conflicts().length) {
      <section class="flex flex-col gap-4">
        <div class="flex gap-2 items-center justify-center">
          <div class="bg-primary-purple-light-2-selected flex items-center justify-center rounded-full p-1">
            <img [src]="images.alert" class="filter-primary-purple-light w-5 h-5" />
          </div>
          <p class="text-sm text-neutrals-grey-06 font-semibold">{{ literalService.get('vehicles.actions.editSchedule.conflicts.text', true) }}</p>
        </div>
        <ul class="flex max-h-60 flex-col gap-2 overflow-y-auto">
          @for (conflict of conflicts(); track conflict.conflictingTrip.id) {
            <li class="flex gap-4 items-center">
              <div class="flex gap-2 bg-primary-purple-light-2-selected border border-primary-purple-light px-2 py-1 items-center rounded">
                <div class="flex gap-4 items-center">
                  <div class="flex gap-2 items-center">
                    <img [src]="images.driver" class="w-5 h-5" />
                    <span
                      class="max-w-30 font-semibold truncate"
                      [id]="`schedule-conflict-driver-name-${$index}`"
                      [tooltip]="conflict.conflictingTrip.driver?.name || ''"
                      [visibleTooltip]="utilsService.visibleTooltip(`schedule-conflict-driver-name-${$index}`)"
                    >
                      {{ conflict.conflictingTrip.driver?.name }}
                    </span>
                  </div>
                  <div class="flex gap-2 items-center">
                    <img [src]="images.busCar" class="w-5 h-5" />
                    <span 
                      class="max-w-30 font-semibold truncate"
                      [id]="`schedule-conflict-vehicle-name-${$index}`"
                      [tooltip]="conflict.conflictingTrip.vehicle?.name || ''"
                      [visibleTooltip]="utilsService.visibleTooltip(`schedule-conflict-vehicle-name-${$index}`)"
                    >
                      {{ conflict.conflictingTrip.vehicle?.name }}
                    </span>
                  </div>
                  <div class="flex gap-2 items-center">
                    <img [src]="images.clock" class="w-5 h-5" />
                    <span
                      class="max-w-30 font-semibold truncate"
                      [id]="`schedule-conflict-times-${$index}`"
                      [tooltip]="timesLabel(conflict.conflictingTrip)"
                      [visibleTooltip]="utilsService.visibleTooltip(`schedule-conflict-times-${$index}`)"
                    >
                      {{ timesLabel(conflict.conflictingTrip) }}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          }
        </ul>
      </section>
    }
  </section>
  @if (conflicts().length) {
    <section class="flex justify-between items-center gap-6">
      <button type="button" class="secondary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer" (click)="cancelConflicts()">{{ literalService.get('cancel', true) }}</button>
      <button type="button" class="primary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer" (click)="confirmConflicts()">{{ literalService.get('confirm', true) }}</button>
    </section>
  } @else {
    <section class="flex justify-between items-center gap-6">
      <button type="button" class="secondary gap-4 p-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer" (click)="cancelForm()">{{ literalService.get('cancel', true) }}</button>
      <button type="submit" class="primary gap-4 px-2 border-2 font-semibold h-10 w-full uppercase cursor-pointer" [disabled]="!canSubmit()" [ngClass]="{ 'cursor-default!': !canSubmit() }">
        @if (checking()) {
          <ng-lottie class="h-full" height="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1.5)" />
        } @else {
          {{ literalService.get('confirm', true) }}
        }
      </button>
    </section>
  }
</form>
